import React, { useRef } from "react";
import "../styles/EnrollSection/EnrollSection.css";
import CountrySelect from "../Components/enroll/CountrySelect";

const EnrollmentForm = () => {
  const formRef = useRef(null);

  // ✅ Default country code set to India
  const countryCodeRef = useRef("+91");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);

    // ✅ Always send country code (default +91)
    formData.append("country_code", countryCodeRef.current);
    formData.append("form_type", "Madhi-Academy SkillTraining Enroll Form");

    try {
      const response = await fetch(
        "https://formsubmit.co/ajax/admission@madhiacademy.com",
        {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        }
      );

      if (response.ok) {
        alert("Enrollment request submitted successfully!");
        formRef.current.reset();

        // Reset country code again after submit
        countryCodeRef.current = "+91";
      } else {
        alert("Submission failed. Please try again.");
      }
    } catch (error) {
      alert("Network error. Please try later.");
    }
  };


  return (
    <div className="enrollment-page-wrapper">
      {/* Header */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-7 col-md-9 text-center text-md-start">
            <h2 className="fw-bold mb-3 text-purple-header">
              Enroll in Skills Courses
            </h2>
            <p className="text-secondary small mb-0">
              Upskill with short, focused courses. Select your course and share your contact details.
            </p>
          </div>
        </div>
      </div>

      {/* Form Section */}
      <section className="enrollment-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-9 col-sm-12">

              <form ref={formRef} onSubmit={handleSubmit}>
                {/* Full Name */}
                <div className="mb-4">
                  <label className="form-label custom-label">
                    Full Name <span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="full_name"
                    className="form-control custom-input"
                    placeholder="Enter Full Name"
                    required
                  />
                </div>

                {/* Email */}
                <div className="mb-4">
                  <label className="form-label custom-label">
                    Email ID <span className="required-star">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="form-control custom-input"
                    placeholder="Enter Your Mail ID"
                    required
                  />
                </div>

                {/* Mobile */}
                <div className="mb-4">
                  <label className="form-label text-white small">
                    Parent / Guardian Mobile{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    {/* ✅ Country Select */}
                    <CountrySelect
                      defaultCode="+91"
                      onChange={(code) => {
                        countryCodeRef.current = code || "+91";
                      }}
                    />

                    <input
                      type="tel"
                      name="mobile"
                      className="form-control custom-input border-start-0 ps-3"
                      placeholder="Enter Mobile Number"
                      required
                    />
                  </div>
                </div>

                {/* City */}
                <div className="mb-4">
                  <label className="form-label custom-label">
                    City <span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="city"
                    className="form-control custom-input"
                    placeholder="Enter Your City"
                    required
                  />
                </div>

                {/* Course Selection */}
                <div className="mb-4">
                  <label className="form-label custom-label mb-2">
                    Course <span className="required-star">*</span>
                  </label>

                  <div className="d-flex flex-column gap-3">
                    <div className="form-check custom-radio">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="course"
                        value="ERP"
                        defaultChecked
                      />
                      <label className="form-check-label custom-label">ERP</label>
                    </div>

                    <div className="form-check custom-radio">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="course"
                        value="Computer Basics"
                      />
                      <label className="form-check-label custom-label">
                        Computer Basics
                      </label>
                    </div>

                    <div className="form-check custom-radio">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="course"
                        value="English Communication"
                      />
                      <label className="form-check-label custom-label">
                        English Communication
                      </label>
                    </div>
                  </div>
                </div>

                {/* Consent */}
                <div className="mb-4 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input rounded-0"
                    required
                  />
                  <label className="form-check-label custom-label small">
                    I agree to be contacted about course schedules and access.
                  </label>
                </div>

                {/* Hidden FormSubmit Settings */}
                <input
                  type="hidden"
                  name="_subject"
                  value="Madhi-Academy SkillTraining Enroll Form"
                />
                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_template" value="table" />

                {/* Submit */}
                <div className="mb-5">
                  <button type="submit" className="btn custom-btn-outline">
                    Enroll Now
                  </button>
                </div>
              </form>
              {/* Privacy */}
              <div className="privacy-line">
                Privacy: Your data is used only for enrollment communication.
                <span className="separator">&nbsp;|&nbsp;</span>
                Support:{" "}
                <a href="mailto:support@madhiacademy.com" className="privacy-link">
                  support@madhiacademy.com
                </a>
                <span className="separator">&nbsp;|&nbsp;</span>
                Contact with Us: 7708941960
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EnrollmentForm;
